import * as React from 'react';
import { Dialog } from "@progress/kendo-react-dialogs";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createUser } from '../../ApiUtils/ApiUtils';
import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons';

interface UserCreateFormProps {
    currentCompany?: string;
    handleClose: any;
    handleFormClose: any;
    submitErrors: any[];
}

interface UserCreateFormState {
    isLoading: boolean;
    submitErrors: any[];
    password: string;
    isPasswordFocused: boolean;
    passwordConfirmation: string;
    [key: string]: any;
    showPassword: boolean;
    showConfirmPassword: boolean;
}

class UserCreateForm extends React.Component<UserCreateFormProps, UserCreateFormState> {
    public constructor(props: UserCreateFormProps) {
        super(props);
        this.state = {
            isLoading: false,
            submitErrors: [],
            password: '',
            isPasswordFocused: false,
            passwordConfirmation: '',
            showPassword: false,
            showConfirmPassword: false
        };
    }

    public validateEmail = (email: string) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    public handleCreateSubmit = (item: any) => {
        item.preventDefault();
        this.setState({
            submitErrors: [],
            isLoading: true
        });

        if (!this.validateEmail(this.state.username)) {
            this.setState({
                submitErrors: ["Username must be a valid email"],
                isLoading: false
            });
            return false;
        }

        if (this.state.username === "") {
            this.setState({
                submitErrors: ["Username required"],
                isLoading: false
            });
            return false;
        }

        if (this.state.password === "") {
            this.setState({
                submitErrors: ["Password fields are required"],
                isLoading: false
            });
            return false;
        }

        if (!this.doPasswordsMatch()) {
            this.setState({
                submitErrors: ["Passwords don't match"],
                isLoading: false
            });
            return false;
        }

        const data = {
            "username": this.state.username,
            "firstName": this.state.firstName,
            "lastName": this.state.lastName,
            "password": this.state.password,
            "passwordTemporary": this.state.passwordTemporary,
            "realm": this.props.currentCompany
        };

        createUser(data).then(response => {
            if (response === "") {
                alert("User " + data.username + " has been created successfully!");
                this.props.handleFormClose();
                return;
            }
            try {
                var result = JSON.parse(response);    

                if (result.error_description) {
                    this.setState({
                        submitErrors: [result.error_description],
                        isLoading: false
                    });
                }         

                if (result.errorMessage) {
                    this.setState({
                        submitErrors: [...this.state.submitErrors, result.errorMessage],
                        isLoading: false
                    });
                }   

            } catch (e) {
                console.error("Error creating user: " + e);
            }
        });
        return false;
    };

    private inputChangeHandler = (event: any) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    private checkboxChangeHandler = (event: any) => {
        this.setState({ [event.target.name]: event.target.checked });
    }

    private handlePasswordFocus = () => {
        this.setState({ isPasswordFocused: true });
    };

    private handlePasswordBlur = () => {
        this.setState({ isPasswordFocused: false });
    };

    private isMinLength = () => {
        return this.state.password.length >= 12;
    }

    private hasUppercase = () => {
        return /[A-Z]/.test(this.state.password);
    }
    private hasLowercase = () => {
        return /[a-z]/.test(this.state.password);
    }

    private hasNumber = () => {
        return /[0-9]/.test(this.state.password);
    }

    private hasSpecialChar = () => {
        return /[^A-Za-z0-9]/.test(this.state.password);
    }

    private doPasswordsMatch = () => {
        return this.state.password && this.state.password === this.state.passwordConfirmation;
    };
    private isPasswordValid = () => {
        return this.isMinLength() && this.hasUppercase() && this.hasLowercase() && this.hasNumber() && this.hasSpecialChar();
    }

    private toggleShowPassword = () => {
        this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
    };

    private toggleShowConfirmPassword = () => {
        this.setState((prevState) => ({ showConfirmPassword: !prevState.showConfirmPassword }));
    };

    public render() {
        const isPasswordValid = this.isPasswordValid();
        return (
            <>
                <Dialog
                    title={"Create new user"}
                    onClose={this.props.handleClose}
                    style={{fontSize:"8px"}}
                    width={500}
                    height={"100%"}
                >
                    <div style={{ position: "relative"}}>
                        <div className="spinner-container" style={{ display: this.state.isLoading ? "block" : "none" }} >
                            {this.state.isLoading && <FontAwesomeIcon icon={faSpinner} size="1x" spin={true} />}
                        </div>
                        <form autoComplete="off" onSubmit={this.handleCreateSubmit} style={{ padding: "10px 15px 0px 15px" }}>
                            <label htmlFor="userName">Username (email)</label><br />
                            <input autoComplete="off" onChange={this.inputChangeHandler} type="text" name="username" id="username" className="field k-input k-input-md k-rounded-md k-input-solid" required /> <br/>

                        <label htmlFor="firstName">First Name</label><br />
                            <input type="text" onChange={this.inputChangeHandler} name="firstName" id="firstName" className="field k-input k-input-md k-rounded-md k-input-solid" /><br/>

                        <label htmlFor="lastName">Last Name</label><br />
                            <input autoComplete="off" onChange={this.inputChangeHandler} type="text" name="lastName" id="lastName" className="field k-input k-input-md k-rounded-md k-input-solid" /><br/>

                            <label htmlFor="password">Password</label><br />
                            <div style={{ position: 'relative' }}>
                                <input autoComplete="off" onChange={this.inputChangeHandler}
                                    onFocus={this.handlePasswordFocus} onBlur={this.handlePasswordBlur}
                                    type={this.state.showPassword ? "text" : "password"}
                                    name="password" id="password"
                                    className="field k-input k-input-md k-rounded-md k-input-solid"
                                    style={{ borderColor: this.state.password ? (isPasswordValid ? 'green' : 'red') : undefined }}
                                    required
                                />
                                <span onClick={this.toggleShowPassword} className="password-eye">
                                    <FontAwesomeIcon icon={this.state.showPassword ? faEyeSlash : faEye} />
                                </span>
                                <br style={{ userSelect: 'none' }} />
                                {this.state.password && this.state.isPasswordFocused && !isPasswordValid && (
                                    <div className="passwordTooltip">
                                        Password must include:
                                        <ul style={{ margin: 0, paddingLeft: '25px' }}>
                                            <li style={{ color: this.isMinLength() ? 'green' : 'red' }}>At least 12 characters</li>
                                            <li style={{ color: this.hasUppercase() ? 'green' : 'red' }}>One uppercase letter</li>
                                            <li style={{ color: this.hasLowercase() ? 'green' : 'red' }}>One lowercase letter</li>
                                            <li style={{ color: this.hasNumber() ? 'green' : 'red' }}>One number</li>
                                            <li style={{ color: this.hasSpecialChar() ? 'green' : 'red' }}>One special character</li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                            <label htmlFor="passwordConfirmation">Password confirmation</label><br />
                            <div style={{ position: 'relative' }}>
                                <input autoComplete="off" onChange={this.inputChangeHandler} value={this.state.passwordConfirmation}
                                    type={this.state.showConfirmPassword ? "text" : "password"}
                                    name="passwordConfirmation" id="passwordConfirmation" className="field k-input k-input-md k-rounded-md k-input-solid"
                                    style={{ borderColor: this.state.passwordConfirmation ? (this.doPasswordsMatch() ? 'green' : 'red') : undefined }}
                                    required />
                                <span onClick={this.toggleShowConfirmPassword} className="password-eye">
                                    <FontAwesomeIcon icon={this.state.showConfirmPassword ? faEyeSlash : faEye} />
                                </span>
                                <br style={{ userSelect: 'none' }} />
                            </div>
                        
                            <input autoComplete="off" onChange={this.checkboxChangeHandler} type="checkbox" id="passwordTemporary" name="passwordTemporary" className={"k-checkbox k-checkbox-md k-rounded-md gds-checkbox"} defaultChecked />
                            <label htmlFor="passwordTemporary">Password temporary?</label>
                            <div style={{ color: "red", height: "50px", lineHeight:"50px" }}>{this.state.submitErrors}</div>

                            <input type="submit" value="Submit" className={"btn btn-primary user-create-button"} />
                            <button className={"btn btn-secondary user-create-button"} onClick={this.props.handleClose}>Cancel</button>
                        </form>
                    </div>
                </Dialog>
            </>
        );
    }
}

export default UserCreateForm;
